export const DEPARTURE_CITY_STORAGE_KEY =
  'free-avia:special-offers-departure-city';
